export default {

	mounted: function () {
		this.sterneSetzen();
		this.modalVerdrahten();
	},

	methods: {

		/* ---------------------------------------------------- Sternenhimmel ---
		   Ersetzt das fehlende Nachtfoto. Die Anzahl steht im Attribut
		   data-stars. Der Hero liegt ausserhalb dieses Containers, daher
		   ueber document und nicht ueber this.$el. */
		sterneSetzen: function () {
			document.querySelectorAll('[data-stars]').forEach(function (box) {
				if (box.children.length) return; // schon gefuellt

				var anzahl = parseInt(box.getAttribute('data-stars'), 10) || 80;
				var imHero = box.closest('.bt-hero') !== null;
				var frag = document.createDocumentFragment();

				for (var i = 0; i < anzahl; i++) {
					var s = document.createElement('i');
					if (i % 7 === 0) s.className = 'bt-lg';
					s.style.left = (Math.random() * 100).toFixed(2) + '%';
					/* Im Hero oben dichter, sonst gleichmaessig verteilt */
					var t = imHero ? Math.pow(Math.random(), 1.6) : Math.random();
					s.style.top = (t * 100).toFixed(2) + '%';
					s.style.animationDelay = (Math.random() * 4.5).toFixed(2) + 's';
					frag.appendChild(s);
				}
				box.appendChild(frag);
			});
		},

		/* --------------------------------------------------- Gutschein-Modal ---
		   Nur Oeffnen, Schliessen und die Vorauswahl der Zustellung. */
		modalVerdrahten: function () {
			var dlg = document.getElementById('voucherDialog');
			if (!dlg || typeof dlg.showModal !== 'function') return;

			var letzterFokus = null;

			function oeffnen() {
				letzterFokus = document.activeElement;
				dlg.showModal();

				/* Print@home ist die Standardzustellung. Ein checked-Attribut
				   wuerde von v-model ueberschrieben, weil formData der
				   Komponente leer startet – daher ein echter Klick: der
				   schreibt in formData und laesst die Summe mitrechnen. */
				if (!dlg.querySelector('input[name="versand"]:checked')) {
					var standard = dlg.querySelector('input[name="versand"]');
					if (standard) standard.click();
				}

				var erstes = dlg.querySelector('input[name="naechte"]');
				if (erstes) erstes.focus({
					preventScroll: true
				});
			}

			function schliessen() {
				dlg.close();
			}

			dlg.addEventListener('close', function () {
				if (letzterFokus) letzterFokus.focus();
			});

			/* Klick auf den Hintergrund schliesst */
			dlg.addEventListener('click', function (e) {
				if (e.target === dlg) schliessen();
			});

			/* Die Ausloeser sind Anker auf #gutschein. Der Klick wird
			   abgefangen – ohne JavaScript bleibt der Sprung auf den
			   Abschnitt als Rueckfalloption. */
			document.querySelectorAll('[data-open-voucher]').forEach(function (b) {
				b.addEventListener('click', function (e) {
					e.preventDefault();
					oeffnen();
				});
			});

			/* Abbrechen liegt im Template der Komponente, daher delegiert */
			document.addEventListener('click', function (e) {
				if (e.target.closest('[data-close-voucher]')) schliessen();
			});
		}

	}

};